import { render, staticRenderFns } from "./CampaignWelcome.vue?vue&type=template&id=406181c5"
import script from "./CampaignWelcome.vue?vue&type=script&lang=js"
export * from "./CampaignWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports